/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector } from '../../../../infra/hooks';
import { offBoardingService } from '../../../../api/services/offBoardingService';
interface PropsValues {
  setReasonsForResignations: (data: any) => void;
  setLettersType: (data: any) => void;
  setHireDateData: (date: any) => void;
}

function DTOOffBoardingForm({
  setReasonsForResignations,
  setLettersType,
  setHireDateData,
}: PropsValues) {
  const selector = useAppSelector((state) => state);
  async function getReasons(empId: number) {
    const response = await offBoardingService.getReasonsForResignation(empId);
    if (response.response == 'success') {
      setReasonsForResignations(response?.data);
    } else {
      return;
    }
  }

  useEffect(() => {
    const lettersData = [
      { id: 0, name: 'No' },
      { id: 1, name: 'Yes' },
    ];
    setLettersType(lettersData);
    if (selector.authSlice.company_id)
      getReasons(selector.authSlice.company_id);
    setHireDateData(selector.authSlice.hire_date);
  }, []);

  return <></>;
}
export default DTOOffBoardingForm;
